import React, { Suspense, useEffect, useState } from 'react'
import Loader from 'react-loaders'
import { set, getDatabase, ref, get, child, onValue } from 'firebase/database'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
// import { getDocs, collection } from 'firebase/firestore';

import { db } from '../../firebase'
import temiLogo from '../../assets/images/logo512.png'
import useWindowDimensions from '../hooks/useWindowDimensions'
import { Link, useNavigate } from 'react-router-dom'

const Portfolio = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const [getDB, setGetDB] = useState(null)
  const [portfolio, setPortfolio] = useState([])
  const [loading, setLoading] = useState(false)

  let navigate = useNavigate()
  const { width } = useWindowDimensions()
  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)

    return () => {
      clearTimeout(timer)
    }
  })

  useEffect(() => {
    const abortController = new AbortController()
    const getPortfolio = async (getDBInfo) => {
      try {
        setLoading(true)
        const dbref = ref(getDBInfo)

        /* get(child(dbref, 'portfolio/')).then((snapshot) => {
                    if (snapshot.exists()) {
                        const arrPortfolio = Object.values(snapshot.val())
                        setPortfolio(arrPortfolio);
                    }
                }) */
        // snapshot.exists(), Object.values(snapshot.val()
        console.warn('snapshot before')
        const snapshot = await get(child(dbref, 'portfolio/'))
        console.warn('snapshot after', snapshot)
        if (abortController.signal) {
          if (snapshot.exists()) {
            const arrPortfolio = Object.values(snapshot.val())
            await setPortfolio(arrPortfolio)
            setLoading(false)
          }
        }
      } catch (error) {
        console.error('error before', error)
        if (!abortController.signal.aborted) {
          console.error('error mmm', error)
          alert('kindly revisit back after 5 seconds to portfolio page ')
          setLoading(false)
          navigate('/')
          // window.location.reload();
        }
      }
    }
    const getDBData = async () => {
      const extractDBData = getDatabase()

      if (abortController.signal) {
        if (extractDBData !== undefined) {
          setGetDB(extractDBData)
          getPortfolio(extractDBData)
        }
      }

      /* const starCountRef = await ref(db, 'portfolio/');
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val();
            }); */
    }
    getDBData()

    return () => {}
  }, [])

  /* useEffect(() => {
        getPortfolio();
    }, []);

    const getPortfolio = async () => {
        const querySnapshot = await getDocs(collection(db, 'portfolio'));
        setPortfolio(querySnapshot.docs.map((doc) => doc.data()));
    } */

  /* useEffect(() => {
        if (getDB) {
            getPortfolio();
        }
    }, []); */

  /* const renderPortfolio = (portfolio) => {
        return (
            <div className="images-container">
                {
                    portfolio.map((port, idx) => {
                        return (
                            <div className="image-box" key={idx}>
                                <img
                                    src={port.image}
                                    className="portfolio-image"
                                    alt="portfolio" />
                                <div className="content">
                                    <p className="title">{port.name}</p>
                                    <h4 className="description">{port.description}</h4>
                                    <button
                                        className="btn"
                                        onClick={() => window.open(port.url)}
                                    >View</button>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        );
    } */

  const renderPortfolio = (portfolio) => {
    return (
      <div
        className={`${
          width < 768 ? 'images-container-mobile' : 'images-container'
        } `}
      >
        {portfolio.length > 0 &&
          portfolio.map((port, idx) => {
            return (
              <div
                className={`${
                  width < 768
                    ? 'image-box-mobile image-box_custom'
                    : 'image-box image-box_custom'
                } `}
                key={idx}
              >
                <Suspense fallback={<Loader type="pacman" />}>
                  <img
                    style={
                      width < 768
                        ? { width: '100%', height: 'auto' }
                        : { display: 'block' }
                    }
                    src={port.cover}
                    className={`${width < 768 ? '' : 'portfolio-image'} `}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null // prevents looping
                      currentTarget.src = temiLogo
                    }}
                    alt="portfolio"
                  />
                </Suspense>

                <div className="content">
                  <p className="title">{port.title}</p>
                  <h4 className="description">{port.description}</h4>
                  <a
                    type="button"
                    href={port.url}
                    target="_blank"
                    className="btn"
                    rel="noreferrer"
                    // onClick={() => window.open(port.url)}
                  >
                    View
                  </a>
                </div>
              </div>
            )
          })}
      </div>
    )
  }

  return (
    <>
      <div className="container portfolio-page">
        <h1 className="page-title">
          <AnimatedLetters
            letterClass={letterClass}
            strArray={'Portfolio'.split('')}
            idx={15}
          />
        </h1>
        {loading && portfolio.length === 0 ? (
          <Loader type="pacman" />
        ) : !loading && portfolio.length > 0 ? (
          <div>{renderPortfolio(portfolio)}</div>
        ) : (
          <div
            className={`${
              width < 768 ? 'images-container-mobile' : 'images-container'
            } `}
          >
            <div
              className={`${
                width < 768
                  ? 'image-box-mobile image-box_custom'
                  : 'image-box image-box_custom'
              } `}
            >
              <div className="content">
                <p className="title">{'No Data'}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default Portfolio
